import { create } from "zustand";

interface SessionState {
    sessionTimeout: boolean;
    setSessionTimeout: (timeout: any) => void;
    resetSessionTimeout: () => void;
}

export const useSessionStore = create<SessionState>(set => ({
    sessionTimeout: false,
    setSessionTimeout: sessionTimeout => set({ sessionTimeout }),
    resetSessionTimeout: () => set({ sessionTimeout: false }),
}));
